var module = angular.module('octopusApp.configuration');
var moment = require('moment');
var humanizeDuration = require('humanize-duration');

module.controller('CertificateConfigurationController', function($scope, busy, octopusRepository, $location, $uibModal) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();
  var certs = octopusRepository.CertificateConfiguration;

  var humanizedTimeDifference = function(start){
    return humanizeDuration(moment() - moment(start), {round: true, largest: 2});
  };

  var promises = [];
  promises.push(certs.getOctopusCertificate().then(function(octopusCertificate) {
    $scope.octopusCertificate = octopusCertificate;
  }));
  promises.push(octopusRepository.LetsEncryptConfiguration.get().then(function(config) {
    $scope.letsEncryptConfiguration = config;
    $scope.letsEncryptCertificateExpiryDate = config.CertificateExpiryDate;
    $scope.letsEncryptCertificateExpiryDateHumanReadable = humanizedTimeDifference(config.CertificateExpiryDate);
  }));
  promises.push(octopusRepository.ServerConfiguration.settings().then(function (configSettings) {
    $scope.configSettings = configSettings;
  }));
  promises.push(octopusRepository.Tasks.filter({name: 'ConfigureLetsEncrypt', take: 10}).then(function(tasks) {
    if (_.size(tasks.Items) > 0) {
      var completedTasks = _.filter(tasks.Items, function(value) { return value.CompletedTime != null; });
      var tasksByCompleted = _.sortBy(completedTasks, 'CompletedTime');

      var task = _.last(tasksByCompleted);
      if (!task) {
        var tasksByCompleted = _.sortBy(tasks.Items, 'CompletedTime');
        task = _.last(tasksByCompleted);
      }

      $scope.lastLetsEncryptTaskSuccess = task.FinishedSuccessfully;
      $scope.lastLetsEncryptTaskTime = task.CompletedTime;
      $scope.lastLetsEncryptTaskTimeHumanReadable = humanizedTimeDifference(task.CompletedTime);
      $scope.lastLetsEncryptTaskUrl = '#/tasks/' + task.Id;
    }
  }));

  isLoading.promises(promises);

  $scope.enableLetsEncryptIntegration = function() {
    $uibModal.open({
      backdrop: true,
      keyboard: true,
      templateUrl: 'areas/configuration/certificates/views/lets_encrypt_dialog.html',
      controller: 'LetsEncryptDialogController',
      controllerAs: 'vm',
      bindToController: true,
      resolve: {
        letsEncryptConfiguration: function () { return $scope.letsEncryptConfiguration; },
        configSettings: function () { return $scope.configSettings; },
      }
    });
  };

  $scope.disableLetsEncryptIntegration = function() {
    isSaving.promise(octopusRepository.LetsEncryptConfiguration.disable($scope.letsEncryptConfiguration).then(function(letsEncryptConfiguration){
      $scope.letsEncryptConfiguration = letsEncryptConfiguration;
    }));
  };

  $scope.renewLetsEncryptCertificate = function() {
    var task = {
        Name: 'ConfigureLetsEncrypt',
        Description: "Renew Let's Encrypt SSL Certificate",
        Arguments: { }
    };
    task.Arguments.DnsName = $scope.letsEncryptConfiguration.DnsName;
    task.Arguments.RegistrationEmailAddress = $scope.letsEncryptConfiguration.RegistrationEmailAddress;
    task.Arguments.AcceptLetsEncryptTermsOfService = $scope.letsEncryptConfiguration.AcceptLetsEncryptTermsOfService;
    task.Arguments.HttpsPort = $scope.letsEncryptConfiguration.HttpsPort;
    task.Arguments.IPAddress = $scope.letsEncryptConfiguration.IPAddress;

    $scope.isLoading.promise(octopusRepository.Tasks.create(task).then(function (result) {
      $location.path("/tasks/" + result.Id);
    }));
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/certificates/controllers/certificates_index_controller.js
// module id = 685915347787421
// module chunks = 1